/* eslint-disable id-length */
/* eslint-disable import/prefer-default-export */

export const SET_RUNTIME_VARIABLE = 'SET_RUNTIME_VARIABLE';
export const SET_LOCALE_START = 'SET_LOCALE_START';
export const SET_LOCALE_SUCCESS = 'SET_LOCALE_SUCCESS';
export const SET_LOCALE_ERROR = 'SET_LOCALE_ERROR';
export const AUTH_CHECK = 'AUTH_CHECK';
export const AUTH_CHECK_SUCCESS = 'AUTH_CHECK_SUCCESS';
export const AUTH_CHECK_FAIL = 'AUTH_CHECK_FAIL';
export const ALERT = 'ALERT';
export const CLOSE_ALERT = 'CLOSE_ALERT';
export const SET_CURRENT_TENANT = 'SET_CURRENT_TENANT';
export const SET_CURRENT_TENANT_LEDGERS = 'SET_CURRENT_TENANT_LEDGERS';
export const REFETCHING_CURRENT_TENANT = 'REFETCHING_CURRENT_TENANT';
export const REFETCH_CURRENT_TENANT = 'REFETCH_CURRENT_TENANT';
export const REFETCH_CURRENT_TENANT_ERROR = 'REFETCH_CURRENT_TENANT_ERROR';
export const REFETCH_CURRENT_TENANT_LEDGER = 'REFETCH_CURRENT_TENANT_LEDGER';
export const REFETCH_CURRENT_TENANT_LEDGER_ERROR = 'REFETCH_CURRENT_TENANT_LEDGER_ERROR';
export const REFETCH_CURRENT_TENANT_LEDGER_SUCCESS = 'REFETCH_CURRENT_TENANT_LEDGER_SUCCESS';
export const SET_CURRENT_FACILITY = 'SET_CURRENT_FACILITY';
export const SET_CURRENT_ACCOUNTS = 'SET_CURRENT_ACCOUNTS';
export const DEFAULT_PROVIDER = 'storedge';
export const TOTALRECALL_PROVIDER = 'totalrecall';
export const CONTACT_TYPE = 'contact';
export const AUTH_USER_TYPE = 'authorized-user';
export const SET_IDLE = 'SET_IDLE';
export const SET_ACTIVE = 'SET_ACTIVE';
export const LOADING_COMPONENT = 'LOADING_COMPONENT';
export const DONE_LOADING = 'DONE_LOADING';
export const US_COUNTRY_CODE = 'us';
export const GB_COUNTRY_CODE = 'gb';
export const CA_COUNTRY_CODE = 'ca';
export const SIGN_OUT = 'SIGN_OUT';
export const UNAUTHENTICATED_ERROR = 'UNAUTHORIZED';
export const MMS_BRAND_NAME = 'Manhattan Mini Storage';
export const STOREDGE_SOFTWARE = 'storedge';
export const SET_CURRENT_USER = 'SET_CURRENT_USER';
export const AMERICAN_EXPRESS_IDENTIFIER = 'ame';
export const TEXT_INPUT_TYPE = 'text';
export const PASSWORD_INPUT_TYPE = 'password';
export const STOREDGE_PASSWORD_INCORRECT_ERROR = 'The login and/or password provided was incorrect.';
export const LOCALE_FR_CA = 'fr-ca';
export const ACH_CARD_TYPE = 'ach';
export const CREDIT_CARD_TYPE = 'credit_card';
export const BACS_CARD_TYPE = 'bacs';
export const PAYMENT_BLOCKED_CC_TOKEN = 'alert.ccPaymentBlocked';
export const PAYMENT_BLOCKED_ACH_TOKEN = 'alert.achPaymentBlocked';

export const PLAID_LOAD_LINK_TOKEN = 'PLAID_LOAD_LINK_TOKEN';
export const PLAID_LINK_TOKEN_SUCCESS = 'PLAID_LINK_TOKEN_SUCCESS';
export const PLAID_LINK_TOKEN_ERROR = 'PLAID_LINK_TOKEN_ERROR';
export const PLAID_CONNECTING = 'PLAID_CONNECTING';
export const PLAID_ACCOUNT_DATA_RECEIVED = 'PLAID_ACCOUNT_DATA_RECEIVED';
export const PLAID_CONNECTED = 'PLAID_CONNECTED';
export const PLAID_ERROR = 'PLAID_ERROR';
export const PLAID_RESET = 'PLAID_RESET';

export const PLAID_STATUS = {
  NotStarted: 'not_started',
  LoadingLinkToken: 'loading_link_token',
  ReadyToConnect: 'ready_to_connect',
  Connecting: 'connecting',
  VerifyingAccount: 'verifying_account',
  Connected: 'connected',
  Error: 'error',
};

export const COUNTRY_CODE_TO_COUNTRY_MAPPING = {
  '+1': 'us',
  '+44': 'gb',
  '+52': 'mx',
  // '+1': 'ca', // Not sure how to differentiate between US and CA
};

export const COUNTRY_TO_COUNTRY_CODE_MAPPING = {
  'us': '+1',
  'gb': '+44',
  'mx': '+52',
  'ca': '+1',
};